import { render, staticRenderFns } from "./SectionShopSlider.vue?vue&type=template&id=fbbddd02&scoped=true&lang=pug&"
import script from "./SectionShopSlider.vue?vue&type=script&lang=js&"
export * from "./SectionShopSlider.vue?vue&type=script&lang=js&"
import style0 from "./SectionShopSlider.vue?vue&type=style&index=0&id=fbbddd02&scoped=true&lang=scss&"
import style1 from "./SectionShopSlider.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbbddd02",
  null
  
)

export default component.exports